const BookCategories = [
  { label: "Book", value: 1 },
  { label: "Novella", value: 2 },
  { label: "Short Story", value: 3 },
  { label: "Graphic Novel", value: 4 },
  { label: "Fan Fiction", value: 5 },
  { label: "Research Paper", value: 6 },
  { label: "Poetry", value: 7 },
  { label: "Collection", value: 8 },
  { label: "Web Novel", value: 9 },
  { label: "Light Novel", value: 10 },
];

export const BookCategoriesAsString = BookCategories.map((category) => {
  return {
    label: category.label,
    value: category.value.toString(),
  }
});

export default BookCategories;

export type BookCategoryType = {
  label: string;
  value: number;
};
